/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { Play } from 'lucide-react'
import SiteShell from '../pages/SiteShell.jsx'
import styles from './Library.module.css'
import './library.css'
import { APP_LIBRARY_URL, EXERCISES, kindColor, libPath, thumbSrc } from './data.js'

function Card({ exercise, eager }) {
  const kind = exercise.kind?.[0]
  return (
    <a className={styles.card + ' seq-lib-card'} href={libPath(exercise.id)}>
      <div className={styles.thumb}>
        <img className={styles.poster} src={thumbSrc(exercise.id)} alt={exercise.title} loading={eager ? 'eager' : 'lazy'} decoding="async" width="480" height="480" />
        <span className={styles.shade} />
        {kind && <span className={styles.kind} style={{ background: kindColor(kind) }}>{kind}</span>}
        <span className={styles.play}><Play size={16} fill="currentColor" /></span>
      </div>
      <div className={styles.overlay}>
        {kind && <div className={styles.tags}><span>{kind}</span></div>}
        <h2 className={styles.name}>{exercise.title}</h2>
        <div className={styles.chips}>
          {exercise.level?.[0] && <span className={styles.chip}>{exercise.level[0]}</span>}
          {exercise.equipment?.[0] && <span className={styles.chip}>{exercise.equipment[0]}</span>}
        </div>
      </div>
    </a>
  )
}

export default function LibraryPage() {
  const list = EXERCISES
  return (
    <SiteShell variant="library">
      <div className="seq-lib-scope">
        <div className={styles.root} dir="rtl">
          <header className={styles.hero} dir="rtl">
            <h1 className={styles.title}>کتابخانه‌ی تمرین‌ها</h1>
            <p className={styles.sub} dir="rtl">
              کتابخانه جامع و هوشمند تمرین‌های ورزشی.
            </p>
            <div className={styles.resultLine} dir="rtl">بیش از ۱۰۰۰ ویدیوی تمرینی</div>
          </header>
          <div className={styles.gridBox}>
            {list.length === 0 ? (
              <div className={styles.empty}>تمرینی با این جستجو پیدا نشد.</div>
            ) : (
              <div className={styles.grid}>
                {list.map((e, i) => <Card key={e.id} exercise={e} eager={i < 4} />)}
              </div>
            )}
          </div>
          <div className="seq-lib-more">
            <a href={APP_LIBRARY_URL} target="_blank" rel="noopener">
              مشاهده‌ی ویدیوهای بیشتر
            </a>
          </div>
        </div>
      </div>
    </SiteShell>
  )
}
